var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { CTA } from '../call-to-action';
import { Breakpoints } from '../helpers/breakpoint';
import { styled } from '../theme-provider';
export const CTAClusterContainer = styled.div.withConfig({ displayName: "CTAClusterContainer", componentId: "sc-dq05bj" }) `display:flex;gap:${({ theme }) => theme.size.static150};pointer-events:all;@media (min-width: ${Breakpoints.b560}px){gap:${({ theme }) => theme.size.static150};}@media (min-width: ${Breakpoints.b960}px){background-color:white;opacity:0.95;border-radius:${({ theme }) => theme.size.static150};padding:${({ theme }) => `${theme.size.static150} ${theme.size.static200}`};:only-child{padding:${({ theme }) => theme.size.static150};}}`;
const CTAWrapper = styled.div.withConfig({ displayName: "CTAWrapper", componentId: "sc-o3m9t3" }) `button{color:${({ theme, active }) => active && theme.colors.button.tertiary.active};}`;
export const ClusteredCTA = (_a) => {
    var { active } = _a, rest = __rest(_a, ["active"]);
    return (React.createElement(CTAWrapper, { active: active },
        React.createElement(CTA, Object.assign({}, rest, { tag: "button", size: "small", emphasis: "tertiary" }))));
};
